"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoSave = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const batch_save_elements_thunk_1 = require("../reducers/slices/document/thunks/batch_save_elements_thunk");
/**
 * Auto-save hook with debouncing
 *
 * Watches for pending updates and automatically triggers batch save
 * after 10 seconds of inactivity.
 *
 * Usage: Call this hook once at the top level of your document editor component
 * ```tsx
 * useAutoSave();
 * ```
 */
const useAutoSave = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { pendingUpdates } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const timeoutRef = (0, react_1.useRef)(null);
    // Count pending updates
    const pendingCount = Object.keys(pendingUpdates).length;
    (0, react_1.useEffect)(() => {
        // Clear existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        // If there are no pending updates, do nothing
        if (pendingCount === 0) {
            return;
        }
        // Set new timeout for 10 seconds
        timeoutRef.current = setTimeout(() => {
            dispatch((0, batch_save_elements_thunk_1.batch_save_elements_thunk)());
        }, 10000); // 10 second debounce
        // Cleanup on unmount or when pendingCount changes
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [pendingCount]);
    // Return pending count for UI display
    return { pendingCount };
};
exports.useAutoSave = useAutoSave;
